import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Header/Header';
import SideBar from '../SideBar/SideBar';
import Breadcrumbs from '../../components/Breadcrumbs.js';
import { GLOBAL_MENU, PUBLISHER_MENU } from '../SideBar/SidebarConfig.js';

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth > 768);

  // get guid from URL
  const { guid, id} = useParams();

  // decide sidebar menu here
  const menuItems = guid ? PUBLISHER_MENU(guid, id) : GLOBAL_MENU;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      // Keep sidebar hidden by default on mobile
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    };
     window.addEventListener("resize", handleResize);
     handleResize();
     return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setCollapsed(prev => !prev);
  };
  console.log("Layout isMobile:", isMobile);
  return (
    <div className="d-flex" style={{height: "100vh",overflow: "hidden"}}>
      {/* <div
        style={{
          minWidth: collapsed ? '70px' : '250px',
          width: collapsed ? '70px' : '250px',
          transition: 'width 0.3s',
          overflow: 'hidden'
        }}
      > */}
      <div
        className={isMobile ? "mobile-sidebar" : ""}
        style={{
          minWidth: isMobile ? 0 : collapsed ? "70px" : "250px",
          width: isMobile ? "250px" : collapsed ? "70px" : "250px",
          transform:
            isMobile && collapsed ? "translateX(-100%)" : "translateX(0)",
          transition: "all 0.3s ease",
          overflow: "hidden",
          position: isMobile ? "fixed" : "relative",
          height: "100vh",
          zIndex: isMobile ? 1050 : 2147483647,
          background: "#fff",
        }}
      >
        <SideBar collapsed={collapsed} menuItems={menuItems}  isMobile={isMobile} onToggleSidebar={toggleSidebar} />
      </div>
        {isMobile && !collapsed && (
          <div
            className="sidebar-overlay"
            onClick={() => setCollapsed(true)}
          />
        )}

      <div className="flex-grow-1 d-flex flex-column" style={{overflow: "hidden", marginLeft: isMobile ? 0 : 0}}>
        <Header onToggleSidebar={toggleSidebar} isMobile={isMobile} collapsed={collapsed} />
        <div className="p-3" style={{ marginTop: '60px', overflowY: "auto", overflowX: "hidden", flex: 1}}>
          {/* <Breadcrumbs /> */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
